
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $7Tdq9 = parcelRequire("7Tdq9");
const $69325bd88fdc98cc$var$SENT_KEY = "contactFormSent";
function $69325bd88fdc98cc$var$getLang() {
    return localStorage.getItem("language") || "ro";
}
function $69325bd88fdc98cc$var$formText(key) {
    const lang = $69325bd88fdc98cc$var$getLang();
    return (0, $7Tdq9.translations)[lang]?.contact?.form?.[key] || (0, $7Tdq9.translations).en.contact.form[key];
}
function $69325bd88fdc98cc$var$clearForm(form) {
    form.reset();
    form.querySelectorAll("input, textarea").forEach((field)=>{
        if (field.type !== "hidden" && field.name !== "_gotcha") field.value = "";
    });
}
function $69325bd88fdc98cc$var$initContactForm() {
    const form = document.querySelector(".contact-form");
    if (!form) return;
    const submitButton = form.querySelector('button[type="submit"]');
    const clearIfSent = ()=>{
        if (sessionStorage.getItem($69325bd88fdc98cc$var$SENT_KEY) === "1") {
            $69325bd88fdc98cc$var$clearForm(form);
            sessionStorage.removeItem($69325bd88fdc98cc$var$SENT_KEY);
        }
    };
    clearIfSent();
    window.addEventListener("pageshow", clearIfSent);
    form.addEventListener("submit", async (event)=>{
        event.preventDefault();
        submitButton.disabled = true;
        submitButton.textContent = $69325bd88fdc98cc$var$formText("sending");
        try {
            const response = await fetch(form.action, {
                method: "POST",
                body: new FormData(form),
                headers: {
                    Accept: "application/json"
                }
            });
            const data = await response.json().catch(()=>({}));
            if (!response.ok || data.error) throw new Error(data.error || $69325bd88fdc98cc$var$formText("error"));
            sessionStorage.setItem($69325bd88fdc98cc$var$SENT_KEY, "1");
            $69325bd88fdc98cc$var$clearForm(form);
            alert($69325bd88fdc98cc$var$formText("success"));
        } catch (error) {
            alert(error.message || $69325bd88fdc98cc$var$formText("error"));
        } finally{
            submitButton.disabled = false;
            submitButton.textContent = $69325bd88fdc98cc$var$formText("submit");
        }
    });
}
$69325bd88fdc98cc$var$initContactForm();


//# sourceMappingURL=contact.a9c157c1.js.map
